import { UnderwritingResultStatus } from '@40seas/entities/underwriting';
import { EnumColor } from '@40seas/frontend/common/providers';

export const underwritingResultStatusColorMapping = {
    [UnderwritingResultStatus.Approved]: 'success',
    [UnderwritingResultStatus.Preapproved]: 'info',
    [UnderwritingResultStatus.Declined]: 'error',
    [UnderwritingResultStatus.ManualReview]: 'default',
} as { [key in UnderwritingResultStatus]: EnumColor };
